export const PAPER_RESPONSE_STATUS_ORDER = {
    'Not Acknowledged': 1,
    'In Progress': 2,
    'Completed': 3,
}

export const PAPER_RESPONSE_STATUS_COMPLETED = 'Completed'

export function getDisabledStatusOptions(selectedStatuses) {
    if (!selectedStatuses || selectedStatuses.length === 0) return []
    const disabled = []
    const hasCompleted = selectedStatuses.includes(PAPER_RESPONSE_STATUS_COMPLETED)
    const hasInProgress = selectedStatuses.includes('In Progress')
    const uniqueStatuses = [...new Set(selectedStatuses)]
    if (hasCompleted) {
        disabled.push('Not Acknowledged')
        disabled.push('In Progress')
    } else if (hasInProgress) {
        disabled.push('Not Acknowledged')
    }
    if (uniqueStatuses.length === 1) {
        disabled.push(uniqueStatuses[0])
    }
    return disabled
}

export function validateStatusTransition(selectedStatuses, newStatus) {
    if (!selectedStatuses || selectedStatuses.length === 0) {
        return ''
    }
    const uniqueStatuses = [...new Set(selectedStatuses)]
    if (uniqueStatuses.length === 1 && uniqueStatuses[0] === newStatus) {
        return `All selected record(s) already have status "${newStatus}". Please choose a different status.`
    }
    const newOrder = PAPER_RESPONSE_STATUS_ORDER[newStatus]
    if (!newOrder) return ''

    const conflicting = []
    selectedStatuses.forEach(currentStatus => {
        const currentOrder = PAPER_RESPONSE_STATUS_ORDER[currentStatus]
        if (currentOrder && currentOrder > newOrder && !conflicting.includes(currentStatus)) {
            conflicting.push(currentStatus)
        }
    })

    if (conflicting.length === 0) return ''

    return `Cannot change status to "${newStatus}". Some selected record(s) currently have status: ${conflicting.join(', ')}. Status cannot be moved backward.`
}

export function validateEditStatusTransition(originalStatus, newStatus) {
    if (!originalStatus || originalStatus === newStatus) {
        return ''
    }
    return validateStatusTransition([originalStatus], newStatus)
}

export function isViewOnlyStatus(status) {
    return status === PAPER_RESPONSE_STATUS_COMPLETED
}

export function getStatusSelectOptions(allOptions, originalStatus) {
    if (!originalStatus) return allOptions
    const disabled = getDisabledStatusOptions([originalStatus])
    return allOptions.filter(opt => !disabled.includes(opt.value) || opt.value === originalStatus)
}
